import { makeHttpRequest } from "@/shared";

import { mapDepositFromServer } from "./mappers/mapDepositsFromServer";

export const getDeposit = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/deposit/${id}`,
            method: "GET",
        })
    ).data;

    return mapDepositFromServer(response.data);
};
